import { AuthModel } from './type';

// The JWT is kept in memory only (module-scoped variable), not in localStorage/sessionStorage.
// Any script running on the page - including one injected via an XSS bug - can still read this
// while it's executing, but the token is no longer left sitting in browser storage where it could
// be scraped later (malware/infostealers reading localStorage on disk, forensic access, etc).
//
// Trade-off: the session does not survive a full page reload or a new tab; the user is signed out
// and must log in again. There's no refresh-token cookie backing this yet.
let authState: AuthModel | undefined;

const getAuth = (): AuthModel | undefined => authState;

const setAuth = (auth: AuthModel) => {
  authState = auth;
};

const removeAuth = () => {
  authState = undefined;
};

export { getAuth, setAuth, removeAuth };
